
import { Truck } from 'lucide-react';

const DeliveryBanner = () => {
  return (
    <div className="bg-gradient-gold-shine text-springbok-800 py-2 sticky top-0 z-[40] w-full">
      <div className="w-full px-4 sm:px-6 lg:px-8 flex items-center justify-center gap-1.5 relative z-10">
        <Truck className="animate-bounce-gentle" size={16} />
        <p className="font-bold text-xs">
          Local delivery on qualifying orders! <span className="opacity-75">(T&Cs apply)</span>
        </p>
      </div>
    </div>
  );
};

export default DeliveryBanner;
